import styled from "styled-components"

const StyledStat = styled.div`
  display: flex;
`

const StyledHighight = styled.div`
  font-size: 4.25rem;
  font-weight: bold;
  color: var(--dark-red);
`

const StyledText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 1rem;
`

const StyledBigText = styled.div`
  font-size: 1.80rem;
`

const StyledSmallText = styled.div`
  font-size: 0.9rem;
`

const StatOverview = ({highlight, bigtext, smalltext}) => {
  return (
    <StyledStat>
      <StyledHighight>
        {highlight}
      </StyledHighight>
      <StyledText>
        <StyledBigText>
          {bigtext}
        </StyledBigText>
        <StyledSmallText>
          {smalltext}
        </StyledSmallText>
      </StyledText>
    </StyledStat>
  )
}

export default StatOverview